import { type PortableTextBlock } from 'next-sanity'

import { buttonSizeClasses } from '@/app/components/Button'
import { CalloutGuide } from '@/app/components/CalloutGuide'
import PortableText from '@/app/components/PortableText'
import { TRACKING_LOCATIONS } from '@/app/utils/analytics'
import { cn } from '@/app/utils/style'
import { GuideTeaser as GuideTeaserProps } from '@/sanity.types'

type DereferencedGuideItem = {
  _key?: string
  calloutLabel?: string | null
  item?: {
    _id: string
    _type: string
    language: 'en' | 'es'
    title: string
    slug: string
    excerpt?: string | null
    featuredImage?: any
  } | null
}

type GuideTeaserWithDereferencedItems = Omit<GuideTeaserProps, 'guideItems'> & {
  guideItems?: DereferencedGuideItem[]
}

type GuideTeaserComponentProps = {
  block: GuideTeaserWithDereferencedItems & { _key?: string }
  index: number
  pageId?: string
  pageType?: string
}

export default function GuideTeaser({ block, pageId, pageType }: GuideTeaserComponentProps) {
  return (
    <div className="content-container my-7xl lg:my-11xl p-5xl lg:p-9xl bg-neutral-50 rounded-md">
      {block?.content?.length && (
        <PortableText
          className={cn('flex flex-col items-center justify-center text-center', 'mx-auto mb-5xl')}
          tracking={{ location: TRACKING_LOCATIONS.PAGE_CONTENT }}
          buttonClassName={buttonSizeClasses({ lg: 'md' })}
          value={block.content as PortableTextBlock[]}
          documentId={pageId}
          documentType={pageType}
          parentPath={block._key ? `pageBuilder[_key=="${block._key}"].content` : undefined}
        />
      )}

      {block?.guideItems?.length && (
        <div className="grid grid-cols-1 gap-4xl md:grid-cols-3 md:max-w-[1010px] md:mx-auto md:items-stretch lg:gap-5xl">
          {block.guideItems.map((guideItemWrapper, index) => {
            if (!guideItemWrapper?.item) return null

            return (
              <CalloutGuide
                key={guideItemWrapper._key || guideItemWrapper.item._id || index}
                guide={guideItemWrapper.item}
                tracking={{ location: TRACKING_LOCATIONS.PAGE_CONTENT }}
                // showButton={true}
                buttonLabel={guideItemWrapper.calloutLabel}
                bgColor="neutral-100"
                showOverline={true}
                wrapInLink={true}
                className="h-full"
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
